export default [
	{
		file: 'Escenario_Elecciones_018032.txt',
		table: 'elecciones',
		cols: [
			{
				name: 'cod_elec',
				definition: 'INT'
			},
			{
				name: 'glosa_elec',
				definition: 'VARCHAR(80)'
			},
			{
				name: 'ele_fecha',
				definition: 'VARCHAR(10)'
			},
			{
				name: 'tipo_zona',
				definition: 'VARCHAR(1)'
			},
			{
				name: 'tipo_eleccion',
				definition: 'VARCHAR(2)'
			},
			{
				name: 'total_electores',
				definition: 'INT'
			}
		],
		primary: 'PRIMARY KEY (cod_elec)'
	},
	{
		file: 'Escenario_Zonas_018032.txt',
		table: 'zonas',
		cols: [
			{
				name: 'cod_zona',
				definition: 'INT'
			},
			{
				name: 'glosa_zona',
				definition: 'VARCHAR(80)'
			},
			{
				name: 'tipo_zona',
				definition: 'VARCHAR(1)'
			},
			{
				name: 'orden_zona',
				definition: 'BIGINT'
			}
		],
		primary: 'PRIMARY KEY (cod_zona, tipo_zona)'
	},
	{
		file: 'Escenario_ZonasPadre_018032.txt',
		table: 'zonas_padre',
		cols: [
			{
				name: 'cod_zona',
				definition: 'INT'
			},
			{
				name: 'tipo_zona',
				definition: 'VARCHAR(1)'
			},
			{
				name: 'cod_zona_pad',
				definition: 'INT'
			},
			{
				name: 'tipo_zona_pad',
				definition: 'VARCHAR(1)'
			}
		],
		primary: 'PRIMARY KEY (cod_zona, tipo_zona, cod_zona_pad, tupo_zona_pad)'
	},
	{
		file: 'Escenario_Partidos_018032.txt',
		table: 'partidos',
		cols: [
			{
				name: 'cod_part',
				definition: 'INT'
			},
			{
				name: 'glosa_part',
				definition: 'VARCHAR(80)'
			},
			{
				name: 'sigla_part',
				definition: 'VARCHAR(10)'
			}
		],
		primary: 'PRIMARY KEY (cod_part)'
	},
	{
		file: 'Escenario_Pactos_018032.txt',
		table: 'pactos',
		cols: [
			{
				name: 'cod_pacto',
				definition: 'INT'
			},
			{
				name: 'letra_pacto',
				definition: 'VARCHAR(1)'
			},
			{
				name: 'glosa_pacto',
				definition: 'VARCHAR(80)'
			}
		],
		primary: 'PRIMARY KEY (cod_pacto)'
	},
	{
		file: 'Escenario_SubPactos_018032.txt',
		table: 'sub_pactos',
		cols: [
			{
				name: 'cod_subp',
				definition: 'INT'
			},
			{
				name: 'cod_pacto',
				definition: 'INT'
			},
			{
				name: 'glosa_subp',
				definition: 'VARCHAR(80)'
			}
		],
		primary: 'PRIMARY KEY (cod_subp)'
	},
	{
		file: 'Escenario_Candidatos_018032.txt',
		table: 'candidatos',
		cols: [
			{
				name: 'cod_cand',
				definition: 'INT'
			},
			{
				name: 'cod_elec',
				definition: 'INT'
			},
			{
				name: 'cod_zona',
				definition: 'INT'
			},
			{
				name: 'can_orden',
				definition: 'INT'
			},
			{
				name: 'glosa_cand',
				definition: 'VARCHAR(100)'
			},
			{
				name: 'cod_part',
				definition: 'INT'
			},
			{
				name: 'cod_pacto',
				definition: 'INT'
			},
			{
				name: 'cod_subp',
				definition: 'INT'
			},
			{
				name: 'cod_ind',
				definition: 'VARCHAR(1)'
			},
			{
				name: 'can_pagina',
				definition: 'INT'
			},
			{
				name: 'glosa_nombre',
				definition: 'VARCHAR(25)'
			},
			{
				name: 'glosa_apellido',
				definition: 'VARCHAR(25)'
			},
			{
				name: 'cod_genero',
				definition: 'VARCHAR(1)'
			}
		],
		primary: 'PRIMARY KEY (cod_cand)'
	},
	{
		table: 'votacion',
		cols: [
			{
				name: 'cod_elec',
				definition: 'INT'
			},
			{
				name: 'ambito',
				definition: 'INT'
			},
			{
				name: 'cod_ambito',
				definition: 'INT'
			},
			{
				name: 'cod_zona',
				definition: 'INT'
			},
			{
				name: 'tipo_zona',
				definition: 'VARCHAR(1)'
			},
			{
				name: 'votos',
				definition: 'INT'
			}
		],
		primary: 'PRIMARY KEY (cod_elec, ambito, cod_ambito, cod_zona, tipo_zona)'
	}
]
